module.exports = ".s-attachement div[body] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.s-attachement input {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px; }\n\n.s-attachement button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 35px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/s-attachement/s-attachement.component.scss
// module id = ./src/app/shared/components/s-attachement/s-attachement.component.scss
// module chunks = main